(function() {

  'use strict';

  /**
   * Bundle Component
   * @type BundleCmpCtrl
   * @name BundleCtrl
   */
  var BundleButtonCmp = {
      bindings: {
        totalPrice: '<',
        itemsQuantity: '<',
        disableClick: '<', 
        onClick: '&',
        title: '<'
      },
      controller: BundleButtonCmpCtrl,
      templateUrl: 'bundle-button.component.html'
  };

  angular.module('itxApp.catalog')
      .component('bundleButton', BundleButtonCmp);

    BundleButtonCmpCtrl.$inject = [];

  function BundleButtonCmpCtrl() {

      var _this = this;
      
      _this.$onInit = function(){
        
        inditex.onReady(function(){
          _this.isOpenForSale = joyr.catalog.utils.isOpenForSale();
        });
        
      };

  }

})();
